import {
	Component,
	computed,
	effect,
	HostListener,
	inject,
	signal,
} from '@angular/core';
import {
	MENU_DROPDOWN,
	MENU_ITEMS,
	MenuDropdown,
	MenuItem,
	MenuLabel,
} from '../../utils/navbar.model';
import { Router, RouterModule } from '@angular/router';
import { ModalLoginComponent } from '../../auth/modal-login/modal-login.component';
import { ModalService } from '../../services/modal.service';
import { UserService } from '../../services/user.service';
import { CommonModule } from '@angular/common';
import { LocalStorageService } from '../../services/localstorageService.service';
import { ROUTESNAVBAR } from '../../app.routes.constants';
import * as bootstrap from 'bootstrap';
import { ModalGenericComponent } from '../modal-generic/modal-generic.component';
@Component({
	selector: 'app-navbar',
	imports: [
		RouterModule,
		ModalLoginComponent,
		CommonModule,
		ModalGenericComponent,
	],
	templateUrl: './navbar.component.html',
	styleUrl: './navbar.component.css',
	standalone: true,
})
export class NavbarComponent {
	private readonly modalService = inject(ModalService);
	private readonly userService = inject(UserService);
	private readonly localStorageService = inject(LocalStorageService);
	private readonly router = inject(Router);

	menuItems: MenuItem[] = MENU_ITEMS;
	menuDropdown: MenuDropdown[] = MENU_DROPDOWN;

	deviceType: 'desktop' | 'tablet' = 'desktop';

	isLoggedIn = false;
	displayMenuItems = signal<MenuItem[]>([]);

	@HostListener('window:resize', ['$event'])
	onResize(event: any) {
		this.checkScreenSize();
	}

	constructor() {
		this.checkScreenSize();

		effect(() => {
			const isAuth = this.userService.userLogged();
			const token = this.localStorageService.getToken();
			const isAuthenticated = isAuth && token;

			const updatedMenuItems = this.menuItems.filter((item) => {
				if (isAuth?.flagForgotpwd) {
					item.disabled = item.label !== MenuLabel.ESCI;
				} else item.disabled = false;

				if (!isAuth) {
					item.disabled = false;
				}

				if (!item.isButton) return true;

				return isAuthenticated
					? [MenuLabel.ESCI, MenuLabel.AREA_RISERVATA].includes(
							item.label as MenuLabel
						)
					: [MenuLabel.PROVA_ORA, MenuLabel.ACCEDI].includes(
							item.label as MenuLabel
						);
			});
			this.displayMenuItems.set(updatedMenuItems);
		});
	}

	openMethod(item: MenuItem) {
		switch (item.label) {
			case MenuLabel.ESCI:
				this.userService.logout();
				this.modalService.openModal('logoutSuccess');
				setTimeout(() => {
					this.router.navigate([ROUTESNAVBAR.HOME]);
					this.modalService.closeModal('logoutSuccess');
				}, 3000);
				break;
			case MenuLabel.AREA_RISERVATA:
				break;
			case MenuLabel.PROVA_ORA:
				break;
			case MenuLabel.ACCEDI:
				this.modalService.openModal('authModal');
				break;
		}
	}

	closeNavbar() {
		const navbar = document.getElementById('navbarNav');
		if (navbar) {
			const bsNavbar =
				bootstrap.Collapse.getInstance(navbar) ||
				new bootstrap.Collapse(navbar);
			bsNavbar.toggle();
		}
	}

	private checkScreenSize() {
		const width = window.innerWidth;
		if (width < 1024) {
			this.deviceType = 'tablet';
		} else {
			this.deviceType = 'desktop';
		}
	}
}
